import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nickname'
})
export class NicknamePipe implements PipeTransform {

  transform(value: string): any {

    if (!value) return 'carregando...';

    let names = value.split(' ');

    return `${names[0]} ${names[names.length - 1] || ''}`.toUpperCase();
  }

}
